/**
 * @generated SignedSource<<38b871fb029548da8d9e87f66db2d4ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type ProblemGeneratorHistoryTypeEnum = "activate" | "create" | "deactivate" | "publish" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator$data = {
  readonly histories: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly type: ProblemGeneratorHistoryTypeEnum;
        readonly " $fragmentSpreads": FragmentRefs<"ProblemGeneratorHistoryDialog_problemGeneratorHistory" | "ProblemGeneratorHistoryTimelineItem_problemGeneratorHistory">;
      };
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
    readonly totalCount: number | null;
  };
  readonly id: string;
  readonly " $fragmentType": "ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator";
};
export type ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator$key = {
  readonly " $data"?: ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "histories"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ProblemGeneratorProblemGeneratorHistoryPaginatorRefreshQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator",
  "selections": [
    {
      "alias": "histories",
      "args": null,
      "concreteType": "ProblemGeneratorHistoryConnection",
      "kind": "LinkedField",
      "name": "__ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator_histories_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProblemGeneratorHistoryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ProblemGeneratorHistory",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProblemGeneratorHistoryDialog_problemGeneratorHistory"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProblemGeneratorHistoryTimelineItem_problemGeneratorHistory"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "ProblemGenerator",
  "abstractKey": null
};
})();

(node as any).hash = "227f710a054fa7796b50808595a24446";

export default node;
